import {
  CREATE_PROJECT_START,
  CREATE_PROJECT_SUCCESS,
  CREATE_PROJECT_FAILURE,
  FETCH_PROJECT_START,
  FETCH_PROJECT_SUCCESS,
  FETCH_PROJECT_FAILURE,
  SET_PROJECTS_INIT,
  UPDATE_PROJECT_START,
  UPDATE_PROJECT_SUCCESS,
  UPDATE_PROJECT_FAILURE,
  COPY_PROJECT_START,
  COPY_PROJECT_SUCCESS,
  COPY_PROJECT_FAILURE,
  FETCH_MASTER_PROJECT_START,
  FETCH_MASTER_PROJECT_SUCCESS,
  FETCH_MASTER_PROJECT_FAILURE,
  FETCH_PACKAGE_START,
  FETCH_PACKAGE_SUCCESS,
  FETCH_PACKAGE_FAILURE,
  CREATE_PACKAGE_START,
  CREATE_PACKAGE_SUCCESS,
  CREATE_PACKAGE_FAILURE,
  CREATE_TAG_START,
  CREATE_TAG_SUCCESS,
  CREATE_TAG_FAILURE,
  RESET_PKGS_TAGS,
  FETCH_TAGS_START,
  FETCH_TAGS_SUCCESS,
  FETCH_TAGS_FAILURE,
  SWITCH_PKG_TAGS,
  SWITCH_TAG_PKG,
  UPDATE_TAGS_START,
  UPDATE_TAGS_SUCCESS,
  UPDATE_TAGS_FAILURE,
  FETCH_ADNAMES_START,
  FETCH_ADNAMES_SUCCESS,
  FETCH_ADNAMES_FAILURE,
  CREATE_PKG_START,
  CREATE_PKG_SUCCESS,
  CREATE_PKG_FAILURE,
  MERGE_IMPORTED_TAGS,
  HIDE_PROGRESS_BAR,
  FETCH_PKGS_START,
  FETCH_PKGS_SUCCESS,
  PKGS_UPDATE_STATUS,
  FETCH_PKGS_FAILURE,
  RESET_TAGS,
  UPDATE_PKG_START,
  UPDATE_PKG_SUCCESS,
  UPDATE_PKG_FAILURE,
  HIDE_PKG_NAV,
  CREATE_TTYPE_START,
  CREATE_TTYPE_SUCCESS,
  CREATE_TTYPE_FAILURE,
  FETCH_TTYPES_START,
  FETCH_TTYPES_SUCCESS,
  FETCH_TTYPES_FAILURE,
  SWITCH_TAG_TT,
  SWITCH_TT_TAG,
  FETCH_ALL_PROJECT_SUCCESS,
  FETCH_TAG_COUNT_START,
  FETCH_TAG_COUNT_SUCCESS,
  FETCH_TAG_COUNT_FAILURE,
  SWITCH_CATEGORY_TAGS,
  SWITCH_INSTYPE_TAGS,
  UPDATE_PROGRESS_COUNT,
  SHOW_PROGRESS_BAR,
  FETCH_TAGS_CANCEL,
  SWITCH_DATASET,
  SWITCH_DATASET_CHILD,
  REFRESH_TAGS_STATUS,
  COPY_TAGS_START,
  COPY_TAGS_SUCCESS,
  COPY_TAGS_FAILURE,
  REMOVE_TAGS_START,
  REMOVE_TAGS_SUCCESS,
  REMOVE_TAGS_FAILURE,
  FETCH_MODEL_BREAK_START,
  FETCH_MODEL_BREAK_SUCCESS,
  FETCH_MODEL_BREAK_FAILURE,
  FETCH_MODEL_BREAK_MUL_START,
  FETCH_MODEL_BREAK_MUL_SUCCESS,
  FETCH_MODEL_BREAK_MUL_FAILURE,
  ADD_UPDATE_PRICE_CONFIG,
  ADD_UPDATE_PRICE_CONFIG_FAILURE,
  ADD_UPDATE_PRICE_CONFIG_SUCCESS,
  DELETE_TAGS_RESPONSE,
  UPDATE_TAGS_RESPONSE,
  USER_EXPIRE_LOGOUT,
  GET_REPORT_START,
  GET_REPORT_SUCCESS,
  REPORT_BATCHES_START,
  REPORT_BATCHES_SUCCESS,
  REPORT_BATCHES_FAILURE,
  REPORT_BATCHES_RESET,
  DELETE_TAGS_START,
  RESTORE_TAGS_START,
  FETCH_REPORT_HUB_STATUS_START,
  FETCH_REPORT_HUB_STATUS_SUCCESS,
  CLEAR_REPORT_HUB_STATUS,
  REPORTHUB_TASK_STATUS_START,
  REPORTHUB_TASK_STATUS_UPDATE,
  SEND_MAIL_START,
  SEND_MAIL_SUCCESS,
  SEND_MAIL_FAILURE,
  FETCH_ARCHIVE_CANCEL,
  COPY_PKG_INIT,
  COPY_PKG_SUCCESS,
  BULK_TAG_CONFIG_START,
  BULK_TAG_CONFIG_SUCCESS,
  BULK_TAG_CONFIG_FAILURE,
  BULK_TAG_CONFIG_STS_START,
  BULK_TAG_CONFIG_STS_SUCCESS,
  BULK_TAG_CONFIG_STS_FAILURE,
  SEND_PRICING_DATA_START,
  SEND_PRICING_DATA_SUCCESS,
  SEND_PRICING_DATA_FAILURE,
  BULK_TAG_CONFIG_CANCEL_START,
  BULK_TAG_CONFIG_CANCEL_SUCCESS,
  BULK_TAG_CONFIG_CANCEL_FAILURE,
  CHANGE_LOADING_PHASE_STS,
  FETCH_TAG_COUNT_PKG_START,
  FETCH_TAG_COUNT_PKG_SUCCESS,
  FETCH_TAG_COUNT_PKG_FAILURE,
  START_LOADER,
  STOP_LOADER,
  PRICE_ITEM_START,
  PRICE_ITEM_SUCCESS,
  PRICE_ITEM_FAILURE,
  ITEM_PRICE_STS_START,
  ITEM_PRICE_STS_SUCCESS,
  ITEM_PRICE_STS_FAILURE,
  QUOTE_SEARCH_START,
  QUOTE_SEARCH_SUCCESS,
  QUOTE_SEARCH_FAILURE,
  CLEAR_QUOTE_SEARCH,
  FETCH_TAGS_WITH_CMNT_START,
  FETCH_TAGS_WITH_CMNT_SUCCESS,
  FETCH_TAGS_WITH_CMNT_FAILURE,
  CLEAR_TAGS_WITH_CMNT,
  FETCH_PKG_CMT_HISTORY_FAILURE,
  FETCH_PKG_CMT_HISTORY_SUCCESS,
  FETCH_PKG_CMT_HISTORY_START,
  UPDATE_PKG_CMT_START,
  UPDATE_PKG_CMT_SUCCESS,
  UPDATE_PKG_CMT_FAILURE,
  UPDATE_PKG_CMT_DELETE,
  EDIT_PKG_CMT_START,
  EDIT_PKG_CMT_SUCCESS,
  EDIT_PKG_CMT_FAILURE,
  CONF_IT_MODEL_STRING_BREAKDOWN_START,
  CONF_IT_MODEL_STRING_BREAKDOWN_SUCCESS,
  CONF_IT_MODEL_STRING_BREAKDOWN_FAILURE
} from "./projTypes";

export const createProject = (payload) => ({
  type: CREATE_PROJECT_START,
  payload,
});

export const createProjectSucc = (cProj) => ({
  type: CREATE_PROJECT_SUCCESS,
  cProj,
});

export const createProjectFailure = (payload) => ({
  type: CREATE_PROJECT_FAILURE,
  payload,
});

export const fetchProjectsAct = (payload) => ({
  type: FETCH_PROJECT_START,
  payload,
});

export const fetchProjectSuccAct = (payload) => ({
  type: FETCH_PROJECT_SUCCESS,
  payload,
});

export const fetchAllProjectSuccAct = (payload) => ({
  type: FETCH_ALL_PROJECT_SUCCESS,
  payload,
});

export const fetchPkgAct = (payload) => ({
  type: FETCH_PACKAGE_START,
  payload,
});

export const fetchPkgSuccAct = (payload) => ({
  type: FETCH_PACKAGE_SUCCESS,
  payload,
});

export const fetchPkgFailAct = (payload) => ({
  type: FETCH_PACKAGE_FAILURE,
  payload,
});

export const fetchProjectFailAct = (payload) => ({
  type: FETCH_PROJECT_FAILURE,
  payload,
});

export const setProjInitAct = (payload) => ({
  type: SET_PROJECTS_INIT,
  payload,
});

export const updateProjectAct = (uProj) => ({
  type: UPDATE_PROJECT_START,
  uProj,
});

export const updateProjectSuccAct = (payload) => ({
  type: UPDATE_PROJECT_SUCCESS,
  payload,
});

export const updateProjectFailAct = (payload) => ({
  type: UPDATE_PROJECT_FAILURE,
  payload,
});

export const copyProject = (payload) => ({
  type: COPY_PROJECT_START,
  payload,
});

export const copyPorjectSucc = (payload) => ({
  type: COPY_PROJECT_SUCCESS,
  payload,
});

export const copyPorjectFail = (payload) => ({
  type: COPY_PROJECT_FAILURE,
  payload,
});

export const fetchMasterProjects = (payload, currMproj) => ({
  type: FETCH_MASTER_PROJECT_START,
  payload,
  currMproj,
});

export const fetchMasterProjectsSucc = (msPrjs) => ({
  type: FETCH_MASTER_PROJECT_SUCCESS,
  projects: msPrjs,
});

export const fetchMasterProjectsFailure = (error) => ({
  type: FETCH_MASTER_PROJECT_FAILURE,
  error,
});

export const createPkgsAct = (payload) => ({
  type: CREATE_PACKAGE_START,
  payload,
});

export const createPkgSuccAct = (cPkg) => ({
  type: CREATE_PACKAGE_SUCCESS,
  packages: cPkg,
});

export const createPkgFailAct = (error) => ({
  type: CREATE_PACKAGE_FAILURE,
  error,
});

export const createTagsAct = (payload, autoCreateTechType) => ({
  type: CREATE_TAG_START,
  payload,
  autoCreateTechType,
});

export const createTagSuccAct = (cTag) => ({
  type: CREATE_TAG_SUCCESS,
  cTag,
});

export const createTagFailAct = (error) => ({
  type: CREATE_TAG_FAILURE,
  error,
});

export const resetPkgsTagsAct = () => ({
  type: RESET_PKGS_TAGS,
});

export const fetchTagsAct = (payload) => ({
  type: FETCH_TAGS_START,
  payload,
});

export const fetchTagsSuccAct = (tags) => ({
  type: FETCH_TAGS_SUCCESS,
  tags,
});
export const resetTagsAct = () => ({
  type: RESET_TAGS,
});

export const mergeImportTags = (tags) => ({
  type: MERGE_IMPORTED_TAGS,
  tags,
});

export const fetchTagsFailAct = (error) => ({
  type: FETCH_TAGS_FAILURE,
  error,
});

export const switchPkgTags = (payload) => ({
  type: SWITCH_PKG_TAGS,
  payload,
});

export const switchTagPkgAct = (payload) => ({
  type: SWITCH_TAG_PKG,
  payload,
});

export const switchTagTTAct = (payload) => ({
  type: SWITCH_TAG_TT,
  payload,
});

export const switchTTTagAct = (payload) => ({
  type: SWITCH_TT_TAG,
  payload,
});

export const switchCategoryTags = (payload) => ({
  type: SWITCH_CATEGORY_TAGS,
  payload,
});

export const switchDataset = (payload) => ({
  type: SWITCH_DATASET,
  payload,
});

export const switchDatasetChild = (payload) => ({
  type: SWITCH_DATASET_CHILD,
  payload,
});

export const switchInsTypeTags = (payload) => ({
  type: SWITCH_INSTYPE_TAGS,
  payload,
});

export const updTagAct = (tag, autoCreateTechType) => ({
  type: UPDATE_TAGS_START,
  tag,
  autoCreateTechType,
});

export const updTagSuccAct = (payload) => ({
  type: UPDATE_TAGS_SUCCESS,
  payload,
});

export const updtTagFailAct = (error) => ({
  type: UPDATE_TAGS_FAILURE,
  error,
});

export const refreshTagStatus = () => ({
  type: REFRESH_TAGS_STATUS,
});
export const fetchADNAct = (name) => ({
  type: FETCH_ADNAMES_START,
  name,
});

export const fetchADNSuccAct = (nameslist) => ({
  type: FETCH_ADNAMES_SUCCESS,
  nameslist,
});

export const fetchADNFailAct = (error) => ({
  type: FETCH_ADNAMES_FAILURE,
  error,
});

export const crPkgAct = (cPkg, project_id, flag) => ({
  type: CREATE_PKG_START,
  cPkg,
  project_id,
  flag
});

export const crPkgSucc = (cPkg, project_id) => ({
  type: CREATE_PKG_SUCCESS,
  cPkg,
  project_id
});

export const crPkgFailure = (payload) => ({
  type: CREATE_PKG_FAILURE,
  payload,
});

export const fPkgsAct = (fPkgs) => ({
  type: FETCH_PKGS_START,
  fPkgs,
});

export const fPkgsUpdtStsAct = (fPkg) => ({
  type: PKGS_UPDATE_STATUS,
  fPkg,
});

export const fPkgsSuccAct = (fPkgs) => ({
  type: FETCH_PKGS_SUCCESS,
  fPkgs,
});

export const fPkgsFailAct = (payload) => ({
  type: FETCH_PKGS_FAILURE,
  payload,
});

export const upPkgAct = (uPkg) => ({
  type: UPDATE_PKG_START,
  uPkg,
});

export const upPkgSuccAct = (uPkg) => ({
  type: UPDATE_PKG_SUCCESS,
  uPkg,
});

export const upPkgFailAct = (payload) => ({
  type: UPDATE_PKG_FAILURE,
  payload,
});

export const hidePkgNav = () => ({
  type: HIDE_PKG_NAV,
});

export const createTTAct = (cTT) => ({
  type: CREATE_TTYPE_START,
  cTT,
});

export const createTTSuccAct = (cTT) => ({
  type: CREATE_TTYPE_SUCCESS,
  cTT,
});

export const createTTFailureAct = (payload) => ({
  type: CREATE_TTYPE_FAILURE,
  payload,
});

export const fTTAct = (fTT) => ({
  type: FETCH_TTYPES_START,
  fTT,
});

export const fTTActSuccAct = (fTT) => ({
  type: FETCH_TTYPES_SUCCESS,
  fTT,
});

export const fTTActFailAct = (payload) => ({
  type: FETCH_TTYPES_FAILURE,
  payload,
});

export const fetchTagCountAct = (payload) => ({
  type: FETCH_TAG_COUNT_START,
  payload,
});

export const fetchTagCountSucc = (payload) => ({
  type: FETCH_TAG_COUNT_SUCCESS,
  payload,
});

export const fetchTagCountFail = (payload) => ({
  type: FETCH_TAG_COUNT_FAILURE,
  payload,
});

export const showProgressBarAct = (payload) => ({
  type: SHOW_PROGRESS_BAR,
  payload,
});

export const updtProgressCntAct = (count) => ({
  type: UPDATE_PROGRESS_COUNT,
  count,
});

export const fetchTagCancelAct = () => ({
  type: FETCH_TAGS_CANCEL,
});

export const fetchArchiveCancelAct = () => ({
  type: FETCH_ARCHIVE_CANCEL,
});


export const hideProgressBar = () => ({
  type: HIDE_PROGRESS_BAR,
});
export const createCopyTag = (payload) => ({
  type: COPY_TAGS_START,
  payload,
});

export const createCopyTagSucc = (cProj) => ({
  type: COPY_TAGS_SUCCESS,
  cProj,
});

export const createCopyTagFailure = (payload) => ({
  type: COPY_TAGS_FAILURE,
  payload,
});
export const removeChildTag = (payload) => ({
  type: REMOVE_TAGS_START,
  payload,
});

export const removeChildTagSucc = (cProj) => ({
  type: REMOVE_TAGS_SUCCESS,
  cProj,
});

export const removeChildTagFailure = (payload) => ({
  type: REMOVE_TAGS_FAILURE,
  payload,
});

export const fmodelbreakAct = (payload) => ({
  type: FETCH_MODEL_BREAK_START,

  payload,
});

export const fmodelbreakSuccAct = (payload) => {
  console.log({ payload });
  return {
    type: FETCH_MODEL_BREAK_SUCCESS,

    payload: payload?.data || [],
  };
};

export const fmodelbreakFailAct = (error) => ({
  type: FETCH_MODEL_BREAK_FAILURE,

  error,
});

export const fModelBreakMulAct = (payload) => {
  //console.log("helloooo in start action", { payload });
  return {
    type: FETCH_MODEL_BREAK_MUL_START,

    payload,
  }
};

export const fModelBreakMulSuccAct = (payload) => {
  //console.log("helloooo in success action", { payload });
  return {
    type: FETCH_MODEL_BREAK_MUL_SUCCESS,

    payload: payload || [],
  };
};

export const fModelBreakMulFailAct = (error) => ({
  type: FETCH_MODEL_BREAK_MUL_FAILURE,

  error,
});

export const addUpdatePriceConfigSubmit = (payload) => ({
  type: ADD_UPDATE_PRICE_CONFIG,
  payload,
});

export const addUpdatePriceConfigSuccess = (payload) => ({
  type: ADD_UPDATE_PRICE_CONFIG_SUCCESS,
  payload,
});

export const addUpdatePriceConfigFailure = (payload) => ({
  type: ADD_UPDATE_PRICE_CONFIG_FAILURE,
  payload,
});
export const updTagRes = (payload) => ({
  type: UPDATE_TAGS_RESPONSE,
  payload,
});
export const delTagRes = () => ({
  type: DELETE_TAGS_RESPONSE,
});

export const userExpireLogout = (payload) => ({
  type: USER_EXPIRE_LOGOUT,
  payload,
});

export const getReport = (payload, pkgDetail) => (
  {
    type: GET_REPORT_START,
    payload,
    pkgDetail
  }
)

export const getReportIDUpdate = (payload) => (
  {
    type: GET_REPORT_SUCCESS,
    payload
  }
)

export const submitReportBatchesStart = (payload) => ({
  type: REPORT_BATCHES_START,
  payload,
});

export const submitReportBatchesSuccess = (payload) => ({
  type: REPORT_BATCHES_SUCCESS,
  payload,
});

export const submitReportBatchesFailure = (payload) => ({
  type: REPORT_BATCHES_FAILURE,
  payload,
});

export const resetReportBatchesState = () => ({
  type: REPORT_BATCHES_RESET,
});

export const deleteTags = (payload) => (
  {
    type: DELETE_TAGS_START,
    payload
  }
)

export const restoreTags = (payload) => (
  {
    type: RESTORE_TAGS_START,
    payload
  }
)

export const fetchReportHubStatus = (payload) => (
  {
    type: FETCH_REPORT_HUB_STATUS_START,
    payload
  }
)

export const fetchReportHubStatusSucc = (reportStatus) => (
  {
    type: FETCH_REPORT_HUB_STATUS_SUCCESS,
    reportStatus
  }
)

export const clearReportHubStatus = () => (
  {
    type: CLEAR_REPORT_HUB_STATUS,
  }
)

export const getReportHubTaskStatus = (taskID, status) => (
  {
    type: REPORTHUB_TASK_STATUS_START,
    taskID, status
  }
)

export const reportHubTaskStatusUpdate = (reportStatusUpd) => (
  {
    type: REPORTHUB_TASK_STATUS_UPDATE,
    reportStatusUpd
  }
)

export const sendMailStart = (payload) => ({
  type: SEND_MAIL_START,
  payload,
});

export const sendMailSuccess = (payload) => ({
  type: SEND_MAIL_SUCCESS,
  payload,
});

export const sendMailFailure = (payload) => ({
  type: SEND_MAIL_FAILURE,
  payload,
});

export const copyPackgeInit = (payload) => ({
  type: COPY_PKG_INIT,
  payload,
});

export const copyPackgeSuccess = (payload) => ({
  type: COPY_PKG_SUCCESS,
  payload,
});

// ---- Bulk TAG configuration--start--
export const bulkTagConfigStart = (payload) => ({
  type: BULK_TAG_CONFIG_START,
  payload,
});
export const bulkTagConfigSuccess = (payload) => ({
  type: BULK_TAG_CONFIG_SUCCESS,
  payload,
});
export const bulkTagConfigFailure = (payload) => ({
  type: BULK_TAG_CONFIG_FAILURE,
  payload,
});

export const bulkTagConfigStatusStart = (payload) => ({
  type: BULK_TAG_CONFIG_STS_START,
  payload,
});
export const bulkTagConfigStatusSuccess = (payload) => ({
  type: BULK_TAG_CONFIG_STS_SUCCESS,
  payload,
});
export const bulkTagConfigStatusFailure = (payload) => ({
  type: BULK_TAG_CONFIG_STS_FAILURE,
  payload,
});

export const bulkTagConfigCancelStart = (payload) => ({
  type: BULK_TAG_CONFIG_CANCEL_START,
  payload,
});
export const bulkTagConfigCancelSuccess = (payload) => ({
  type: BULK_TAG_CONFIG_CANCEL_SUCCESS,
  payload,
});
export const bulkTagConfigCancelFailure = (payload) => ({
  type: BULK_TAG_CONFIG_CANCEL_FAILURE,
  payload,
});
export const changeLoadingPhaseStatus = (payload) => ({
  type: CHANGE_LOADING_PHASE_STS,
  payload,
});

// ---- Bulk TAG configuration--end--

//---for pricing--start---

export const postpricingdatastart = (payload) => {
  console.log("helloooo in success action", { payload });
  return {
    type: SEND_PRICING_DATA_START,
    payload,
  }
};

export const postpricingdataSuccess = (payload) => ({
  type: SEND_PRICING_DATA_SUCCESS,
  payload,
});

export const postpricingdataFailure = (payload) => ({
  type: SEND_PRICING_DATA_FAILURE,
  payload,
});

//---for pricing--end---

export const fetchTagCountPkgAct = (payload) => ({
  type: FETCH_TAG_COUNT_PKG_START,
  payload,
});

export const fetchTagCountPkgSucc = (payload) => ({
  type: FETCH_TAG_COUNT_PKG_SUCCESS,
  payload,
});

export const fetchTagCountPkgFail = (payload) => ({
  type: FETCH_TAG_COUNT_PKG_FAILURE,
  payload,
});

export const startLoader = () => ({
  type: START_LOADER,
});

export const stopLoader = () => ({
  type: STOP_LOADER,
});

export const priceItemSubmit = (payload) => ({
  type: PRICE_ITEM_START,
  payload,
});

export const priceItemSuccess = (payload) => ({
  type: PRICE_ITEM_SUCCESS,
  payload,
});

export const priceItemFailure = (payload) => ({
  type: PRICE_ITEM_FAILURE,
  payload,
});

export const itemPriceStatusStart = (payload) => ({
  type: ITEM_PRICE_STS_START,
  payload,
});
export const itemPriceStatusSuccess = (payload) => ({
  type: ITEM_PRICE_STS_SUCCESS,
  payload,
});
export const itemPriceStatusFailure = (payload) => ({
  type: ITEM_PRICE_STS_FAILURE,
  payload,
});

export const quoteSearchStart = (payload) => ({
  type: QUOTE_SEARCH_START,
  payload,
});

export const quoteSearchSuccess = (payload) => ({
  type: QUOTE_SEARCH_SUCCESS,
  payload,
});

export const quoteSearchFailure = (payload) => ({
  type: QUOTE_SEARCH_FAILURE,
  payload,
});

export const clearQuoteSearch = () => ({
  type: CLEAR_QUOTE_SEARCH,
});


export const fetchTagsWithCmntStart = (payload) => ({
  type: FETCH_TAGS_WITH_CMNT_START,
  payload,
});

export const fetchTagsWithCmntSuccess = (payload) => ({
  type: FETCH_TAGS_WITH_CMNT_SUCCESS,
  payload,
});

export const fetchTagsWithCmntFailure = (payload) => ({
  type: FETCH_TAGS_WITH_CMNT_FAILURE,
  payload,
});

export const clearTagsWithCmnt = () => ({
  type: CLEAR_TAGS_WITH_CMNT,
});

export const fetchPkgCmntHistoryStart = (payload) => ({
  type: FETCH_PKG_CMT_HISTORY_START,
  payload,
});

export const fetchPkgCmntHistorySuccess = (payload) => ({
  type: FETCH_PKG_CMT_HISTORY_SUCCESS,
  payload,
});

export const fetchPkgCmntHistoryFailure = (payload) => ({
  type: FETCH_PKG_CMT_HISTORY_FAILURE,
  payload,
});

export const updatePkgCmntStart = (payload) => ({
  type: UPDATE_PKG_CMT_START,
  payload,
});

export const updatePkgCmntSuccess = (payload) => ({
  type: UPDATE_PKG_CMT_SUCCESS,
  payload,
});

export const updatePkgCmntFailure = (payload) => ({
  type: UPDATE_PKG_CMT_FAILURE,
  payload,
});
export const updatePkgCmntDelete = (payload) => ({
  type: UPDATE_PKG_CMT_DELETE,
  payload,
});

export const editPkgCmntStart = (payload) => ({
  type: EDIT_PKG_CMT_START,
  payload,
});

export const editPkgCmntSuccess = (payload) => ({
  type: EDIT_PKG_CMT_SUCCESS,
  payload,
});

export const editPkgCmntFailure = (payload) => ({
  type: EDIT_PKG_CMT_FAILURE,
  payload,
});

export const confITModelBreakdownStart = (payload) => ({
  type: CONF_IT_MODEL_STRING_BREAKDOWN_START,
  payload,
});

export const confITModelBreakdownSuccess = (payload) => ({
  type: CONF_IT_MODEL_STRING_BREAKDOWN_SUCCESS,
  payload,
});

export const confITModelBreakdownFailure = (payload) => ({
  type: CONF_IT_MODEL_STRING_BREAKDOWN_FAILURE,
  payload,
});